import PlusIcon from 'iconsax-react/dist/esm/Add';
import React from 'react';
import { TDR } from 'tdr-common';
import X from '../../icons/x.svg';
import {
	ImageCard,
	ImageCardAsset,
	ImageCardDescription,
	ImageCardFooter,
	ImageCardHeader,
	ImageCardHeaderPrimary,
	ImageCardHeaderSecondary,
	ImageCardHeaderTitle
} from '../image-card/ImageCard';
import { InputStepper } from '../input-stepper/InputStepper';
import AddOnPriceLabel from '../price-label/AddOnPriceLabel';
import { useTranslation } from 'react-i18next';
import { resolveLocalizedText } from '@/helpers/resolveLocalizedText';

 type AddOnProduct = {
 	id: string;
 	title: string;
 	tag: string;
 	description?: string;
 	leadTimeHours?: number;
 	variantId: string;
 	isSignatureItem: boolean;
 	unit: string;
 	price: {
 		amount: number;
 		unit: string;
 	};
 	imageUrl: string;
 	maxQuantityPerItem?: number;
 };

type AddOnItemProps = {
	product: AddOnProduct;
	restaurant: TDR.Restaurant;
	updateAddOns: (id: string, quantity: number, variantId: string) => void;
	initialQuantity?: number;
	maxQuantity?: number;
};

export const AddOnItem = ({ product, restaurant, updateAddOns, initialQuantity = 0, maxQuantity }: AddOnItemProps) => {
	const { t, i18n } = useTranslation();
	const localizedTitle = resolveLocalizedText(product.title as unknown as string, i18n.language);
	const localizedDescription = resolveLocalizedText(product.description as unknown as string, i18n.language);
	const localizedTag = resolveLocalizedText(product.tag as unknown as string, i18n.language);
	const localizedUnit = resolveLocalizedText(product.unit as unknown as string, i18n.language);
	const handleAddOnChange = (quantity: number) => {
		updateAddOns(product.id, quantity, product.variantId);
		if (product.description) {
			setShowDescription(true);
		}
	};
	const [showDescription, setShowDescription] = React.useState(false);

	return (
		<div className="flex flex-col gap-4">
			<ImageCard height={416}>
				<ImageCardAsset src={product.imageUrl} alt={localizedTitle} />

				<ImageCardHeader>
					<ImageCardHeaderPrimary>
						<ImageCardHeaderTitle>{localizedTitle}</ImageCardHeaderTitle>
					</ImageCardHeaderPrimary>

					<ImageCardHeaderSecondary onClick={() => setShowDescription(!showDescription)}>
						{showDescription ? t('actions.close', { defaultValue: 'Close' }) : t('actions.info', { defaultValue: 'Info' })}
						{showDescription ? <img src={X} alt={t('aria.close_button', { defaultValue: 'Close button' })} /> : <PlusIcon />}
					</ImageCardHeaderSecondary>
				</ImageCardHeader>

				<ImageCardDescription isVisible={showDescription}>
					<p>{localizedDescription}</p>
				</ImageCardDescription>

				{localizedTag && (
					<ImageCardFooter>
						<span>{localizedTag?.toUpperCase()}</span>
					</ImageCardFooter>
				)}
			</ImageCard>

			<div className="flex justify-between items-center">
				<AddOnPriceLabel
					priceAmount={product.price.amount}
					currency={restaurant.currency}
					displayUnit={localizedUnit}
					isSignatureProduct={product.isSignatureItem}
				/>
				<InputStepper onChange={handleAddOnChange} initialCount={initialQuantity} maxQuantity={maxQuantity ?? product.maxQuantityPerItem ?? Infinity} />
			</div>
		</div>
	);
};
